import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Footer from "../Modules/Footer";
import { ViewAndDownload } from "../Modules/Helper";
import NavigationBar from "../Modules/NavigationBar";

export default function Legal() {
	return (
		<>
			<Helmet>
				<title>{"EarsOnly | Legal"}</title>
			</Helmet>
			<NavigationBar />
			<Container className="eo-page">
				<p className="eo-page__overline">Legal</p>
				<h1 className="eo-page__title">Wet- en regelgeving</h1>
				<p className="eo-page__lead">Privacy, algemene voorwaarden en conformiteitsverklaringen. / Privacy, terms and declarations of conformity.</p>

				<section className="eo-doc-group">
					<h2 className="eo-doc-group__title">Nederlands</h2>
					<ViewAndDownload lang="NL" title="Privacyverklaring" path="/documents/legal/Nederlands/EarsOnlyPrivacyverklaringNL.pdf" />
					<ViewAndDownload lang="NL" title="EU-conformiteitsverklaring - D0002" path="/documents/legal/Nederlands/SPE-DP016-012_v1.0_DoC_EU_DECLARATION_OF_CONFORMITY-NL.pdf" />
					<ViewAndDownload lang="NL" title="Algemene Voorwaarden (Wederverkoop)" path="/documents/legal/Nederlands/EarsOnly_ALGEMENE_VOORWAARDEN_Wederverkoop_NL.pdf" />
				</section>

				<section className="eo-doc-group">
					<h2 className="eo-doc-group__title">English</h2>
					<ViewAndDownload title="Privacy Policy" path="/documents/legal/English/MyEarsOnlyPrivacyPolicy.pdf" />
					<ViewAndDownload title="EU Declaration of Conformity - D0002" path="/documents/legal/English/SPE-DP016-012_v1.0_DoC_EU_DECLARATION_OF_CONFORMITY-EN.pdf" />
					<ViewAndDownload title="Terms of service (Resale)" path="/documents/legal/English/EarsOnly_GENERAL_TERMS-Resale_EN.pdf" />
					<ViewAndDownload title="EU Declaration of Conformity - D0001" path="/documents/SPE-DP011-003_v2.0_DoC_EU_DECLARATION_OF_CONFORMITY.pdf" />
				</section>
			</Container>
			<Footer />
		</>
	);
}
